import { DateTime } from "luxon";

import type {
  ActionFilters,
  EventFilters,
  EventFilter,
  ActionFilter,
} from "@/components/event-action/filter/FilterTypes";

export default function getDefaultEABFilter(
  eventFilters: EventFilter[] = [],
  actionFilters: ActionFilter[] = [],
) {
  const defaultEventFilters: EventFilters = {
    updatedAt: DateTime.now(),
    eventFilters,
  };
  const defaultActionFilters: ActionFilters = {
    updatedAt: DateTime.now(),
    actionFilters,
  };
  return {
    defaultEventFilters,
    defaultActionFilters,
  };
}
